module.exports = __webpack_public_path__ + "static/media/logo.69c257e6.png";